/* eslint-disable operator-assignment */
// import * as CryptoJS from 'crypto-js';
import { orgaznizationProperties } from './constants';

function getBaseDomain(hostname) {
  // Regular expression to match domain parts
  const domainParts = hostname.split('.');

  // If there are only two parts (like example.com), return the first part
  if (domainParts.length <= 2) {
    return domainParts[0];
  }

  // For domains with more than two parts (like www.example.co.uk or api.nextias.com),
  // you usually want the second-to-last part (the base domain).
  return domainParts[domainParts.length - 2];
}

function getCurrentOrganization() {
  const hostname = typeof window === 'undefined' ? 'nextias.com' : window.location.host;
  // const hostname = 'winter.madeeasyprime.com';
  // console.log('getCurrentOrganization', hostname)
  const baseDomain = getBaseDomain(hostname);
  return orgaznizationProperties[baseDomain] || {};
}

function getCurrentOrgName() {
  const orgDetails = getCurrentOrganization();
  return orgDetails?.organizationName;
}
export { getCurrentOrganization, getCurrentOrgName };
